/** The caller's active workspace, sent as X-Workspace-Id on every API request
 *  (see api.ts's authHeaders). Mirrors how api.ts stores the auth token:
 *  a single localStorage key, read/written defensively. */

const WORKSPACE_KEY = "ai-agents.workspace"

export function getActiveWorkspaceId(): string | null {
  try {
    return localStorage.getItem(WORKSPACE_KEY)
  } catch {
    return null
  }
}

export function setActiveWorkspaceId(id: string | null): void {
  try {
    if (id) localStorage.setItem(WORKSPACE_KEY, id)
    else localStorage.removeItem(WORKSPACE_KEY)
  } catch {
    /* private browsing, or storage disabled */
  }
}
